export default {
    labelOldPassword: 'Old Password',
    labelNewPassword: 'New Password',
    labelConfirmPassword: 'Confirm Password',
    buttonSave: 'Save',
};
